import { useMutation } from '@tanstack/react-query';
import { del, patch } from '../libs';

interface Payload {
  /** 메모 id */
  coachMemoId: string;
}

/**
 * 코치 - 메모내용 삭제
 * @link https://api-dev.fibud.kr/api#/%EA%B3%84%EC%A0%95/AccountsController_deleteCoachMemo
 * @param param0
 * @returns
 */
export default function useDeleteMemoMutation() {
  return useMutation(({ coachMemoId }: Payload) =>
    del<string>(`/accounts/coach-memo/${coachMemoId}`)
  );
}
